export const features=[
    {text:'-  The best products start with Figma'},
    {text:'-  Design with real data'},
    {text:'-  Lightning fast prototyping'},
    {text:'-  Fastest way to organize'},
    {text:'-  Work at the speed of thought.'}   
]
